module.exports = "../dist/frontend/icons/ui/mouse.svg?fecc12b2b7c3a69e2201c284c12f48bd";